module.exports = __webpack_public_path__ + "static/img/product-poster-3.38e345f2.png";